import { z } from 'zod'

export type AccessRequestStatus =
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'completed'
  | 'cancelled'
  | 'expired'

export const ACCESS_REQUEST_STATUS_LABEL: Record<AccessRequestStatus, string> = {
  pending: 'Bíður prókúruhafa',
  approved: 'Samþykkt — óafgreidd',
  rejected: 'Hafnað',
  completed: 'Aðgangur stofnaður',
  cancelled: 'Felld niður',
  expired: 'Útrunnin',
}

/** What the applicant fills in on the public form. `website` is the honeypot. */
export const AccessRequestCreateSchema = z.object({
  companyKennitala: z.string().min(1),
  companyName: z.string().optional(),
  applicantKennitala: z.string().min(1),
  applicantName: z.string().min(2),
  applicantEmail: z.string().email(),
  applicantPhone: z.string().min(7),
  approverName: z.string().min(2),
  approverEmail: z.string().email(),
  website: z.string().optional(),
})

export type AccessRequestCreate = z.infer<typeof AccessRequestCreateSchema>

/** What the prókúruhafi sees behind the approval link — never the token itself. */
export interface AccessRequestApprovalView {
  companyKennitala: string
  companyName: string | null
  applicantName: string
  applicantEmail: string
  applicantPhone: string
  approverName: string
  status: AccessRequestStatus
  selfApproved: boolean
  createdAt: string
  expiresAt: string
}

export interface AccessRequestAdminRow {
  id: string
  companyKennitala: string
  companyName: string | null
  applicantName: string
  applicantKennitala: string
  applicantEmail: string
  applicantPhone: string
  approverName: string
  approverEmail: string
  selfApproved: boolean
  status: AccessRequestStatus
  registryVerified: boolean | null
  registryNote: string | null
  decidedAt: string | null
  decisionNote: string | null
  completedAt: string | null
  createdAt: string
}
